import React from "react";
import { WrappedFieldProps } from "redux-form";

import { FormTextInput as FormTextInputBase } from "@seneca/senekit";

type Props = WrappedFieldProps & {
  isMulti: boolean;
  label: React.ReactNode;
  placeholder: string;
  size?: "small" | "medium";
};

export function FormTextInput(props: Props) {
  const {
    input: { name, value, onChange, onBlur },
    meta: { error, submitFailed },
    label,
    placeholder,
    ...otherProps
  } = props;

  return (
    // @ts-ignore
    <FormTextInputBase
      name={name}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      label={label}
      placeholder={placeholder}
      showError={submitFailed && !!error}
      error={error}
      {...otherProps}
    />
  );
}
